import { render, staticRenderFns } from "./volume-statistics.vue?vue&type=template&id=7eee788c&scoped=true"
import script from "./volume-statistics.vue?vue&type=script&lang=js"
export * from "./volume-statistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eee788c",
  null
  
)

export default component.exports